import api from '@/api'
import { auth, authAll, dateFormat, calcImageUrl, copy, clickTableJumpLink, getElementLoadingSvg } from '@/util'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
import Cookies from 'js-cookie'
import hotkeys from 'hotkeys-js'
import mitt from 'mitt'

export default function globalProperties(app) {
    // 请求
    app.config.globalProperties.$api = api
    // 鉴权
    app.config.globalProperties.$auth = auth
    app.config.globalProperties.$authAll = authAll
    // 日期格式化
    app.config.globalProperties.$dateFormat = dateFormat
    app.config.globalProperties.$copy = copy
    app.config.globalProperties.$clickTableJumpLink = clickTableJumpLink
    app.config.globalProperties.$elementLoadingSvg = getElementLoadingSvg()
    app.config.globalProperties.$calcImageUrl = calcImageUrl
    app.config.globalProperties.$uploadBaseUrl = import.meta.env.DEV ? 'http://localhost:9000/proxy' : import.meta.env.VITE_APP_API_BASEURL
    app.config.globalProperties.$imageBaseUrl = import.meta.env.VITE_APP_IMAGE_BASEURL
    dayjs.locale('zh-cn')
    app.config.globalProperties.$dayjs = dayjs
    app.config.globalProperties.$cookies = Cookies
    app.config.globalProperties.$hotkeys = hotkeys
    app.config.globalProperties.$eventBus = mitt()
}
